import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.cashierControlFoodPage.setFetching(isFetching)

const fetchOrders = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const {
    me: { id },
    marketplace: { accessLevel: { edu, rpc } },
  } = getState()
  const { cashierAccessLevel } = !isRpc ? edu : rpc

  const schoolId = cashierAccessLevel.find(({ cashier }) => id === cashier.id).school.id

  return request.post(prefix.cashierSchool + `/${schoolId}?thisWeek=true`, {})
    .then(({ data }) => data)
    .then((orders) => reducers.marketplace.cashierControlFoodPage.setOrders(orders))
    .catch((error) => console.log(error))
}

const checkOrder = (orderId) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu

  return request.post(prefix.cashierIssue + `/${orderId}`, {})
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}


export default {
  setFetching,
  fetchOrders,
  checkOrder,
}
